import React from "react";

import MicroFrontend from "../micro-frontend/MicroFrontend";

export const MyMicroFrontend = ({ route }) => (
  <MicroFrontend host={route.host} name={route.microServiceName} moduleId={route.moduleId} />
);
